export default __webpack_public_path__ + "static/media/header-onboarding-3.04f4806e.gif";